import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Switch,
  FormControl,
  Select,
  TextField,
} from "@mui/material";

import { GridColDef } from "@mui/x-data-grid";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validations";
import {
  useChangeUserStatusMutation,
  useExportCsvMutation,
  useIndividualUsersListMutation,
  useLazyDeleteUserQuery,
} from "../../service/users";
import {
  CommonBody,
  Permission,
  UsersList,
  VisaApplicant,
} from "../../types/General";
import { errorToast, successToast } from "../../helpers";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import moment from "moment";
import TableComponent from "../../components/TableComponent";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { UPDATE_TYPES, USER_ROLES } from "../../utils/enums";
import useAuth from "../../hooks/useAuth";

const Individuals = () => {
  const navigate = useNavigate();
  const userData = useAuth();
  const [hidePermission, setHidePermission] = useState<Permission>();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [open, setOpen] = useState(false);
  const [usersList] = useIndividualUsersListMutation();
  const [deleteUser] = useLazyDeleteUserQuery();
  const [changeStatus] = useChangeUserStatusMutation();
  const [exportCsv] = useExportCsvMutation();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<UsersList[] | VisaApplicant[]>([]);
  const [page, setPage] = useState<number>(1);
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  // <--------EXPORT CSV DATE---------->
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // List of years (e.g., last 30 years)
  const years = Array.from({ length: 30 }, (_, i) => currentYear - i);

  // List of months, filtered if current year
  const allMonths = moment.months().map((label, index) => ({
    label,
    value: index + 1,
  }));

  const filteredMonths = allMonths.filter((m) => {
    if (parseInt(year) === currentYear) {
      return m.value <= currentMonth;
    }
    return true;
  });

  // Returns the 1st day of selected month
  const getMinDate = () => {
    return moment(`${year}-01-01`).format("YYYY-MM-DD"); // Start of selected year
  };

  const getMaxDate = () => {
    const today = moment();
    const selectedYear = parseInt(year);

    if (selectedYear === today.year()) {
      return today.format("YYYY-MM-DD");
    }
    return moment(`${year}-12-31`).format("YYYY-MM-DD"); // End of year
  };

  // Auto-set from/to date when year or month changes
  useEffect(() => {
    if (year && month) {
      const start = moment(`${year}-${String(month).padStart(2, "0")}-01`);
      const today = moment();
      const isCurrentMonth =
        start.isSame(today, "month") && start.isSame(today, "year");

      const end = isCurrentMonth ? today : moment(start).endOf("month");

      setFromDate(start.format("YYYY-MM-DD"));
      setToDate(end.format("YYYY-MM-DD"));
    }
  }, [year, month]);

  // <--------EXPORT CSV DATE---------->
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: number
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId(null);
  };
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 300,
      field: "name",
      headerName: "User Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure onClick={() => navigate(`/users/individual/${row?.id}`)}>
              <img
                src={
                  row?.profile_picture?.media_url ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>
                {row?.first_name || "-"} {row?.middle_name || ""}{" "}
                {row?.last_name || ""}
              </b>{" "}
              {row?.country_code} {row?.phone_no || "-"} <br />
              {row?.email || "-"}
            </p>
          </div>
        );
      },
    },
    // {
    //   flex: 1,
    //   minWidth: 150,
    //   field: "registredBy",
    //   headerName: "Registered By",
    //   editable: false,
    //   sortable: false,
    //   renderCell: ({ row }) => {
    //     return (
    //       <div className="user_block">
    //         <p></p>
    //       </div>
    //     );
    //   },
    // },
    {
      flex: 1,
      minWidth: 150,
      field: "registrationDate",
      headerName: "Registration Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {row?.created_at
                ? moment(row?.created_at).format("DD MMM YYYY")
                : "-"}
            </p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 300,
      field: "address",
      headerName: "Complete Address",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.address || "-"}</p>
          </div>
        );
      },
    },
    // {
    //   flex: 1,
    //   minWidth: 100,
    //   field: "nationality",
    //   headerName: "Nationality",
    //   editable: false,
    //   sortable: false,
    //   renderCell: ({ row }) => {
    //     return (
    //       <div className="user_block">
    //         <p>{row?.nationality || "-"}</p>
    //       </div>
    //     );
    //   },
    // },
    {
      flex: 0.1,
      minWidth: 150,
      field: "status",
      filterable: false,
      sortable: false,
      headerName: "Status",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.is_active}
            onChange={() =>
              handleUserUpdate(row?.id, !row?.is_active, UPDATE_TYPES.BLOCK)
            }
          />
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={(event) => handleClick1(event, row?.id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => navigate(`/users/individual/${selectedId}`)}
                >
                  View
                </MenuItem>
                {userData?.user_role_type === USER_ROLES.ADMIN ||
                hidePermission?.can_add_edit ? (
                  <MenuItem
                    onClick={() =>
                      navigate(`/users/individual/edit/${selectedId}`)
                    }
                  >
                    Edit
                  </MenuItem>
                ) : null}
                {userData?.user_role_type === USER_ROLES.ADMIN ||
                hidePermission?.can_be_delete ? (
                  <MenuItem
                    onClick={() => {
                      setAnchorEl1(null);
                      setOpen(true);
                    }}
                  >
                    Delete
                  </MenuItem>
                ) : null}
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];
  const handleDeleteUser = async () => {
    setLoading(true);
    try {
      const response = await deleteUser({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        successToast("Deleted successfully");
        getUsersList();
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleUserUpdate = async (id: number, status: any, type: string) => {
    const body = {
      ...(type === UPDATE_TYPES.BLOCK ? { is_active: status } : {}),
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await changeStatus({
        body: encryptedBody,
        id: id,
      }).unwrap();
      if (response?.status === 200) {
        const updatedData = rows?.map((item) => {
          if (item?.id === id) {
            return {
              ...item,
              is_active: status,
            };
          }
          return item;
        });
        setRows(updatedData);
        if (status === true) {
          successToast("Status enabled successfully");
        } else {
          successToast("Status disabled successfully");
        }
      } else {
        errorToast("Please try again");
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  const getUsersList = async () => {
    setLoading(true);

    try {
      const body = {
        start: page,
        length: 10,
        search: debouncedSearchTerm.trim(),
        ...(fromDate && toDate ? { from_date: fromDate, to_date: toDate } : {}),
      };

      if (fromDate.split("-").join("") > toDate.split("-").join("")) {
        errorToast("Start date can not be greater than end date ");
        setLoading(false);
        return;
      }

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await usersList(encryptedBody).unwrap();

      if (response?.status === 200) {
        setRows(response?.data?.response_object || []);
        setCount(response?.data?.total_records);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "Failed to fetch user list.");
    } finally {
      setLoading(false);
    }
  };

  const handleExportCSV = async () => {
    setLoading(true);
    try {
      const body = {
        role: USER_ROLES.INDIVIDUAL,
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await exportCsv(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        window.open(response?.file_urls);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsersList();
  }, [debouncedSearchTerm, page, fromDate, toDate]);

  const checkPermission = () => {
    const permission = userData?.role_permission;
    if (permission?.length) {
      const foundPermission = permission?.find(
        (ele: Permission) => ele?.module === "Users"
      );

      if (foundPermission) {
        setHidePermission(foundPermission);
      } else {
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    if (userData?.user_role_type === USER_ROLES.SUBADMIN) {
      checkPermission();
    }
  }, [userData]);

  useEffect(() => {
    if (typeof hidePermission !== "undefined") {
      if (!hidePermission?.can_view) {
        navigate("/permission-denied", { replace: true });
      }
    }
  }, [hidePermission, userData]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Individuals</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Users
          - Individuals
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search individuals"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box
                display="flex"
                gap={1.5}
                flexWrap="nowrap"
                alignItems="center"
              >
                <FormControl
                  size="small"
                  className="btn btn_highlight"
                  sx={{ minWidth: 100 }}
                >
                  <Select
                    // labelId="year-label"
                    value={year}
                    onChange={(e) => {
                      setYear(e.target.value);
                      setMonth("");
                      setFromDate("");
                      setToDate("");
                    }}
                    // label="Year"
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Year
                    </MenuItem>
                    {years.map((y) => (
                      <MenuItem key={y} value={y.toString()}>
                        {y}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {year && (
                  <FormControl
                    size="small"
                    className="btn btn_highlight"
                    sx={{ minWidth: 120 }}
                  >
                    {/* <InputLabel id="month-label">Month</InputLabel> */}
                    <Select
                      value={month}
                      onChange={(e) => setMonth(e.target.value)}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select Month
                      </MenuItem>
                      {filteredMonths.map((m) => (
                        <MenuItem key={m.value} value={m.value}>
                          {m.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {year && month && (
                  <>
                    <TextField
                      type="date"
                      fullWidth
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      inputProps={{
                        min: getMinDate(),
                        max: getMaxDate(),
                      }}
                    />

                    <TextField
                      type="date"
                      fullWidth
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      inputProps={{
                        min: fromDate || getMinDate(),
                        max: getMaxDate(),
                      }}
                    />
                  </>
                )}
              </Box>
              <Box>
                <Button className="btn btn_highlight" onClick={handleExportCSV}>
                  <img src="/static/images/upload_icon.svg" alt="Icon" /> Export
                  CSV
                </Button>
              </Box>
            </div>
          </div>
          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={rows}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </div>
        </Box>
        <ConfirmationModal
          text={"Are you sure to delete this individual?"}
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={handleDeleteUser}
        />
      </div>
    </MainContainer>
  );
};

export default Individuals;
